// extracted by mini-css-extract-plugin
module.exports = {"oneBuyer":"style_oneBuyer__2aHoq"};